import * as React from "react"
import "../styles/components/login-form.less"

import { Link } from "gatsby";
import isUserLoggedIn from "../functions/is-user-logged-in"
import Notice from "../components/notice"
import Button from "../components/button"
const afterLoginRedirect = '/ebanking'

class LoginForm extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            error: false,
            success: false,
            redirectProps: false,
            savedHash: false,
            
        };

        this.submitAction = this.submitAction.bind(this);
        this.runRedirect = this.runRedirect.bind(this);
    }

    runRedirect(ref) {
        if ( !ref ) return
        ref.click()
    }

    componentDidMount() {
        let redirectProps = {};
        decodeURI(window.location.hash).substring(1).split('&').forEach( hashFilter => {
			let name = decodeURI(hashFilter).split('=')
			redirectProps[ name[0] ] = name[1]
		});

        const savedHash = window.location.hash.replace(`&loginRedirect=${redirectProps.loginRedirect}`, '')
        this.setState({ redirectProps: redirectProps, savedHash: savedHash })
    }

    isMail(string) {
        const regex = /^([A-Z0-9._%+-]+)@([A-Z0-9.-]+\.[A-Z]{2,4})$/gi;
        return Boolean(string.match(regex))
    }

    logIn(username) {
        window.localStorage.setItem('currentUser', username)
        this.setState({success: 'You have successfully logged in'})
    }

    loginError() {
        this.setState({error: 'This login does not exist'})
    }

    submitAction(event) {
        event.preventDefault();
        this.setState({error: false})

        const input = event.target.querySelector('input[name~="login"]').value.toLowerCase()
        const users = JSON.parse(window.localStorage.getItem('users'))

        if ( this.isMail( input ) ) {
            const user = Object.entries(users).find(user => user[1].email === input) ?? false
            Boolean( user ) ? this.logIn( user[0] ) : this.loginError()

        } else {
            Boolean( users[ input ] ) ? this.logIn( input ) : this.loginError()
        }
    }


    render() {
        const { redirectProps, savedHash } = this.state

        return (
            <>  
                { isUserLoggedIn() && <Link to={ redirectProps.loginRedirect ? `/${redirectProps.loginRedirect}/${savedHash}` : afterLoginRedirect } ref={ this.runRedirect }></Link> }

                <div className="content align--center">
                    { this.state.error ? (<Notice type="error">{this.state.error}</Notice>) : '' }
                    { this.state.success ? (<Notice type="success">{this.state.success}</Notice>) : '' }
                </div>

                <div className="login-form">
                    <div className="align--center">
                        <h3>Log in</h3>
                    </div>

                    <form id="login-form" onSubmit={ this.submitAction }>
                        <label>
                            Login:
                            <input type="text" name="login" id="login" required/>
                        </label>
                        <label>
                            Password:
                            <input type="password" name="password" id="password" required/>
                        </label>

                        <div className="btns">
                            <Button type="secondary" to="/" className="btn--inline">Cancel</Button>
                            <button className="btn btn--primary btn--inline">Log In</button>
                        </div>
                    </form>
                    <p>Don't have an account? <Link to={'/register/'} data-disable-delay><strong>Register here.</strong></Link></p>
                </div>
            </>
        )
    }
}

export default LoginForm